import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { EmployeeSalaryTypeActions } from '../State/actions/employee-salary-type.actions';
import { getEmployeeSalaryTypeFetched } from '../State/selectors/employee-salary-type.selector';
import { BaseEntityResolver } from './resolver.helper';

@Injectable({
    providedIn: 'root',
})
export class EmployeeSalaryTypeResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getEmployeeSalaryTypeFetched, EmployeeSalaryTypeActions.load({ Payload: {} }), store);
    }
}
